import { hasOwnDatabase } from './user-db-sync'

export const userIsRetailer = (user) =>
  hasOwnDatabase(user)
